import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasShower = createSelector(selectJsonQuery, jsonQuery => getTermValue('shower')(jsonQuery));
